import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { authorButton, authorInput, safeSourceUrl } from './qmsAuthoring';

const TYPES = { assembly:{ endpoint:'assembly-instructions', response:'items' }, test:{ endpoint:'test-library', response:'entries' }, bom:{ endpoint:'boms', response:'boms' } };

export default function PinnedReferences({ value = [], onChange, editing = false }) {
  const { getToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [opening, setOpening] = useState(false);
  const update = (i,key,next) => onChange(value.map((r,j) => i === j ? { ...r, [key]:next } : r));
  async function open(reference) {
    if (opening || !reference.revision || !TYPES[reference.type]) return;
    setOpening(true); setError('');
    try {
      const type = TYPES[reference.type];
      const token = await getToken();
      const search = reference.documentNumber.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const res = await window.fetch(`${process.env.REACT_APP_API_URL}/quality/${type.endpoint}?search=${encodeURIComponent(search)}`, { headers:{ Authorization:`Bearer ${token}` } });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.message || data.error || 'Could not resolve reference');
      const matches = (data[type.response] || []).filter(r => r.documentNumber === reference.documentNumber);
      if (matches.length !== 1) throw new Error('The exact document is not available to this account. No substitute revision was opened.');
      navigate(`/quality/${type.endpoint}/${matches[0]._id}?revision=${encodeURIComponent(reference.revision)}`);
    } catch (err) { setError(err.message); }
    finally { setOpening(false); }
  }
  return <div>
    {!value.length && <p style={{ fontSize:12, color:'var(--ni-text-muted)' }}>No pinned procedure references.</p>}
    {value.map((r,i) => <div key={i} style={{ display:'flex', flexWrap:'wrap', alignItems:'center', gap:8, marginBottom:8 }}>
      {editing ? <>
        <select aria-label={`Reference ${i+1} type`} value={r.type || 'assembly'} style={{ ...authorInput, width:130 }} onChange={e => update(i,'type',e.target.value)}>
          {['assembly','test','instruction','bom'].map(t => <option key={t}>{t}</option>)}
        </select>
        <input aria-label={`Reference ${i+1} document`} placeholder="Document number" value={r.documentNumber || ''} onChange={e => update(i,'documentNumber',e.target.value)} style={{ ...authorInput, width:210 }} />
        <input aria-label={`Reference ${i+1} revision`} placeholder="Exact revision" value={r.revision || ''} onChange={e => update(i,'revision',e.target.value)} style={{ ...authorInput, width:120 }} />
        <input aria-label={`Reference ${i+1} URL`} placeholder="Optional source URL" value={r.url || ''} onChange={e => update(i,'url',e.target.value)} style={authorInput} />
        <button type="button" style={authorButton} onClick={() => onChange(value.filter((_,j) => i !== j))}>Remove reference</button>
      </> : <>
        <span style={{ fontFamily:'monospace', fontSize:13 }}>{r.documentNumber} {r.revision || '— revision missing'}</span>
        {safeSourceUrl(r.url) && <a href={safeSourceUrl(r.url)} target="_blank" rel="noreferrer" style={{ fontSize:12 }}>Reference source</a>}
      </>}
      {TYPES[r.type] && <button type="button" style={authorButton} disabled={opening || !r.revision || !r.documentNumber} onClick={() => open(r)}>Open exact revision</button>}
    </div>)}
    {editing && <button type="button" style={authorButton} onClick={() => onChange([...value,{ type:'assembly', documentNumber:'', revision:'', url:'' }])}>Add pinned reference</button>}
    {error && <p role="alert" style={{ color:'#EC2124', fontSize:12 }}>{error}</p>}
  </div>;
}
